import {Theme} from '../Theme'

export const THEME_LIGHT: Theme = {
  black: '#000000',
  black_1: '#242424',
  black_2: '#141414',
  danger_1: '#FDDDD6',
  danger_2: '#FBB4AF',
  danger_3: '#F48587',
  danger_4: '#EA6474',
  danger_5: '#DD3559',
  danger_6: '#BE2655',
  danger_7: '#9F1A50',
  danger_8: '#801048',
  danger_9: '#6A0A43',
  gray_1: '#E6E6E6',
  gray_2: '#CCCCCC',
  gray_3: '#B3B3B3',
  gray_4: '#999999',
  gray_5: '#808080',
  gray_6: '#666666',
  gray_7: '#4D4D4D',
  gray_8: '#333333',
  gray_9: '#1A1A1A',
  info_1: '#CAF6FC',
  info_2: '#96E8FA',
  info_3: '#60CEF1',
  info_4: '#39B0E4',
  info_5: '#0086D3',
  info_6: '#0068B5',
  info_7: '#004D97',
  info_8: '#00377A',
  info_9: '#002765',
  primary_1: '#F9E0F8',
  primary_2: '#F2C3F3',
  primary_3: '#D69BDD',
  primary_4: '#AF75BC',
  primary_5: '#7E4890',
  primary_6: '#65347B',
  primary_7: '#4D2467',
  primary_8: '#371653',
  primary_9: '#270D45',
  success_1: '#E4FBD1',
  success_2: '#C5F7A5',
  success_3: '#98E774',
  success_4: '#6CCF4F',
  success_5: '#35AF1F',
  success_6: '#209616',
  success_7: '#0F7D0F',
  success_8: '#096511',
  success_9: '#055312',
  warning_1: '#FDF4CB',
  warning_2: '#FCE797',
  warning_3: '#F8D463',
  warning_4: '#F1C03C',
  warning_5: '#E8A200',
  warning_6: '#C78500',
  warning_7: '#A76A00',
  warning_8: '#865100',
  warning_9: '#6F3F00',
  white_1: '#FFFFFF',
  white_2: '#FCFCFC',
  white_3: '#F0F0F0',
  white_4: '#F5F5F5',
}
